export const cs = {
  menuBar: {
    file: {
      newFile: 'Nový vzor',
      savePNG: 'Uložit jako PNG',
      saveJPG: 'Uložit jako JPG',
      saveProject: 'Uložit projekt',
      openProject: 'Otevřít projekt',
      unsavedChangesWarning: 'Máte neuložené změny. Opravdu chcete vytvořit nový vzor?'
    },
    display: {
      showGuides: 'Zobrazit vodítka'
    },
    donate: 'Podpořit projekt',
    undo: 'Zpět',
    redo: 'Znovu'
  },
  newProject: {
    title: 'Nový vzor',
    settings: {
      wedges: 'Počet klínů',
      rows: 'Počet řad',
      circleStep: 'Krok kruhu',
      radialStep: 'Krok paprsků',
      stitchScale: 'Velikost ok'
    },
    buttons: {
      create: 'Vytvořit',
      cancel: 'Zrušit'
    }
  },
  stitchTypes: {
    title: 'Typy ok',
    color: 'Barva oka',
    'single': 'Pevné oko',
    'double': 'Krátký sloupek',
    'treble': 'Dlouhý sloupek',
    'chain': 'Řetízkové oko',
    'slip': 'Spojovací oko',
    'half-double': 'Polosloupek',
    'magic-ring': 'Magický kroužek',
    'picot': 'Pikot',
    'double-treble': 'Trojitý sloupek',
    'triple-treble': 'Čtveritý sloupek',
    'front-post-dc': 'Reliéfní přední',
    'back-post-dc': 'Reliéfní zadní'
  },
  help: {
    title: 'User Guide',
    close: 'Close',
    basics: {
      title: 'Basic Usage',
      content: 'Doily.app is an editor for creating circular crochet patterns. Select a stitch type and color from the right panel, then click on the canvas to place stitches. You can drag placed stitches to reposition them. Click a stitch to select it, press Delete to remove it, or Escape to deselect.'
    },
    stitches: {
      title: 'Stitches and Placement',
      content: 'The right panel offers over 40 stitch variants organized in five categories: basic stitches (chain, slip, single, half-double, double, treble, double treble, triple treble, picot, puffs, clusters), increases, decreases, misc (magic ring, front/back loop, front/back post DC), and markers (numbered and directional). Many stitches have variant options — click the small dropdown arrow below a stitch to switch between them. Hover over the canvas to see a placement preview, then click to place. Use Ctrl+Z (Cmd+Z on Mac) to undo and Ctrl+Shift+Z to redo.'
    },
    orientation: {
      title: 'Orientation Center',
      content: 'The orientation crosshair determines the direction stitches face — they automatically rotate to point toward it. Ctrl+click (Cmd+click on Mac) anywhere on the canvas to move it. Double-click the orientation center to reset it to the pattern center.'
    },
    symmetry: {
      title: 'Radial Symmetry',
      content: 'Use the Symmetry dropdown in the top toolbar to enable radial symmetry (2 to 36 axes). When active, every stitch you place is automatically duplicated around the center. Ghost previews show where copies will appear. Hold Shift while placing to temporarily skip symmetry for a single stitch. You can delete or drag individual copies independently.'
    },
    guides: {
      title: 'Guide Lines',
      content: 'Guides help with precise stitch placement. Toggle them with the "Show Guides" checkbox in the top toolbar. The grid shows radial lines and concentric circles based on your project settings. When symmetry is active, dashed blue lines show the symmetry axes. Guide visibility also affects exported images.'
    },
    colors: {
      title: 'Working with Colors',
      content: 'Choose a stitch color from the 40-color palette in the right panel. Hover over a swatch to see its hex code. All newly placed stitches use the selected color. To change an existing stitch\'s color, select the Recolor tool (paint bucket icon in the toolbar), then click or drag over stitches to repaint them.'
    },
    saving: {
      title: 'Saving Your Pattern',
      content: 'Your pattern is automatically saved in the browser as you work. Use the file menu to: create a new pattern, save as PNG or JPG (the exported image includes a legend of all stitch types used), export an editable .doilyapp project file you can share or back up, or open a previously saved project.'
    },
    tools: {
      title: 'Eraser and Recolor Tools',
      content: 'The toolbar includes an Eraser (X icon) and a Recolor tool (paint bucket). Click the tool icon to activate it, then click or drag across stitches on the canvas. The Eraser removes stitches, and the Recolor tool changes them to the currently selected color. Click the tool icon again to deactivate it.'
    }
  },
  stitchesPanel: {
    symmetry: 'Symetrie',
    symmetryOff: 'Vyp',
    eraser: 'Guma',
    recolor: 'Změnit barvu',
    group_stitch: 'Oka', group_increase: 'Přidání', group_decrease: 'Ubírání', group_misc: 'Ostatní', group_marker: 'Značky',
  },
  copyright: {
    text: '© {year} Vytvořeno Julie N. pomocí',
    cursor: 'Cursor'
  },
  legend: {
    signature: 'Vytvořeno pomocí doily.app.craftodejnice.cz'
  }
}; 